import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import modules from './modules'

Vue.use(Vuex)

// Load store modules dynamically.
// const requireContext = require.context('./modules', false, /.*\.js$/)

// const modules = requireContext.keys()
//     .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
//     .reduce((modules, [name, module]) => {
//         modules[name] = module
//         return modules
//     }, {})

// console.log("modulesoooo", modules)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules,
    plugins: [createPersistedState({paths:["settings"], storage: window.sessionStorage})]
})


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js